import styled from "styled-components"

const TextSectionBackground = styled.div`
  background-color: #f8f9f2;
  padding: ${props => props.pa || "1rem 5%"};
  text-align: center;
`

export default TextSectionBackground
